import React, { useEffect, useRef, useState } from 'react';
import { getTimeByUtcOffset } from '@/utils/intl';
import { intlFormatDate } from '@/utils/formatDate';
import { DATE_TIME_FORMAT } from '@/config';

const RealTimeClock = () => {
  const [timeStr, setTimeStr] = useState<string>();

  const timer = useRef<any>();

  useEffect(() => {
    function getCurrentTime() {
      setTimeStr(intlFormatDate(getTimeByUtcOffset(), DATE_TIME_FORMAT));
    }

    timer.current = setInterval(() => {
      getCurrentTime();
    }, 1000);

    return () => {
      clearInterval(timer.current);
      timer.current = null;
    };
  }, []);

  return <>{timeStr}</>;
};

export default RealTimeClock;
